import React, { useEffect } from 'react';
import Button from '@saucelabs/sl-component-buttons';
import { Col, Row } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';

import {
  CONFIGURATION_TEST_TYPES,
  DOCUMENTATION_EVENTS,
  JOBS_UI_ELEMENTS,
  NAVIGATION_EVENTS,
  trackEvent,
} from './../../tracking';
import Styles from './EmptyState.styles';
import Image from './empty-manual.png';

const ManualJobsEmptyState = () => {
  useEffect(() => {
    trackEvent(NAVIGATION_EVENTS.VIEW_JOB_LIST, { state: 'Empty State' });
  }, []);
  return (
    <Row
      className={Styles['empty-state-flex-container']}
      middle="xs"
      xs={12}
    >
      <Col xs={12}>
        <Row
          center="xs"
          className={Styles['empty-state-flex']}
          xs={8}
        >
          <Col
            xl={4}
            xs={8}
          >
            <h3>Run Your First Manual Test</h3>
            <p>
              Quickly spin up a live manual test and accurately reproduce a workflow across hundreds
              of operating system and browser combinations.
            </p>
            <p>
              Easily share video recordings, screenshots, or log files of your test with your team
              members.
            </p>
            <br />
            <>
              <div>
                <Link
                  onClick={() => trackEvent(
                    NAVIGATION_EVENTS.MANUAL_JOB,
                    {
                      testType: CONFIGURATION_TEST_TYPES.WEB,
                      state: 'Empty State',
                      target: JOBS_UI_ELEMENTS.NEW_WEB_TEST_BUTTON_EMPTY_STATE,
                    },
                  )}
                  to="/live/web-testing"
                >
                  <Button
                    category="action"
                    withArrow
                  >
                    New Live Web Test
                  </Button>
                </Link>
              </div>
              <br />
              <div>
                <Link
                  onClick={() => trackEvent(
                    NAVIGATION_EVENTS.MANUAL_JOB,
                    {
                      testType: CONFIGURATION_TEST_TYPES.APP,
                      state: 'Empty State',
                      target: JOBS_UI_ELEMENTS.NEW_APP_TEST_BUTTON_EMPTY_STATE,
                    },
                  )}
                  to="/live/app-testing"
                >
                  <Button
                    category="action"
                    withArrow
                  >
                    New Live App Test
                  </Button>
                </Link>
              </div>
            </>
            <br />
            <h3>Helpful Resources</h3>
            <p>
              <Link
                onClick={() => trackEvent(
                  DOCUMENTATION_EVENTS.HELPFUL_RESOURCE,
                  {
                    helplink: 'Manual Testing Guide',
                  },
                )}
                to="/getting-started/manual-testing"
              >
                Manual Testing Guide
              </Link>
              <br />
              <a
                href="https://wiki.saucelabs.com/display/DOCS/Sharing+the+Results+of+Sauce+Labs+Tests"
                onClick={() => trackEvent(
                  DOCUMENTATION_EVENTS.HELPFUL_RESOURCE,
                  {
                    helplink: 'Sharing SL test results',
                  },
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                Sharing Sauce Labs test results
              </a>
              <br />
              <a
                href="https://wiki.saucelabs.com/display/DOCS/Basic+Sauce+Connect+Proxy+Setup"
                onClick={() => trackEvent(
                  DOCUMENTATION_EVENTS.HELPFUL_RESOURCE,
                  {
                    helplink: 'How to securely test',
                  },
                )}
                rel="noopener noreferrer"
                target="_blank"
              >
                How to securely test locally behind a firewall
              </a>
            </p>
          </Col>
          <Col
            xl={4}
            xs={8}
          >
            <img
              alt="Self-Serve Saucebot Mascot"
              className={Styles['saucebot-mascot']}
              src={Image}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ManualJobsEmptyState;
